import './scroll-animations.scss'

const observer = new IntersectionObserver(
  entries =>
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        observer.unobserve(entry.target)
        entry.target.classList.add('animate')
      }
    }),
  { threshold: 0.45 }
)

export default page => {
  // observer.disconnect()
  page.querySelectorAll('[data-scroll-animation]').forEach(el => {
    if (
      el.dataset.scrollAnimation === 'children' &&
      el.dataset.childAnimationClass
    ) {
      Array.from(el.children).forEach(child => {
        child.classList.add(el.dataset.childAnimationClass)
        observer.observe(child)
      })
    } else {
      observer.observe(el)
    }
  })
}
